import { Injectable } from '@angular/core';
import { SETTINGS } from '../config/common.settings';
import { HttpClient } from '@angular/common/http';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { NzMessageService } from 'ng-zorro-antd/message';

@Injectable({
  providedIn: 'root',
})
export class ActsService {
  constructor(
    private http: HttpClient,
    private ngxLoader: NgxUiLoaderService,
    private message: NzMessageService,
  ) {}

  getActs(year?: number, page: number = 1, pageSize: number = 24): Promise<any> {
    this.ngxLoader.start();
    let url = `${SETTINGS.CMS_API}/api/acts?page=${page}&limit=${pageSize}`;
    if (year) {
      url += `&where[year][equals]=${year}`;
    }
    return new Promise((resolve, reject) => {
      return this.http.get(url).subscribe(
        (response) => {
          this.ngxLoader.stop();
          resolve(response);
        },
        (error) => {
          this.ngxLoader.stop();
          this.message.create('error', 'Failed to retrieve Acts');
          reject(error);
        },
      );
    });
  }

  getYears(): Promise<any> {
    return new Promise((resolve, reject) => {
      return this.http.get(`${SETTINGS.CMS_API}/api/acts?limit=1000`).subscribe(
        (response: any) => {
          if (response && response.docs) {
            const allYears = response.docs
              .map((item: any) => Number(item.year))
              .filter(Boolean) as number[];
            const uniqueYears = [...new Set<number>(allYears)].sort((a, b) => b - a);
            resolve(uniqueYears);
          } else {
            resolve([]);
          }
        },
        (error) => {
          this.message.create('error', 'Failed to retrieve years');
          reject(error);
        },
      );
    });
  }
}


